import type { PlayerSettings } from "@/lib/media/embed";

/** Catalog fiche fullscreen: always show controls and sound. */
export const CATALOG_FULLSCREEN_PLAYER_OVERRIDES: Partial<PlayerSettings> = {
  playerControls: true,
  playerMuted: false,
  playerAutoplay: false,
};

export function mergePlayerSettings(
  settings: PlayerSettings,
  overrides?: Partial<PlayerSettings>,
): PlayerSettings {
  return overrides ? { ...settings, ...overrides } : settings;
}
